export default __webpack_public_path__ + "navigation-examples-custom-waypoint-1200-816a75fcaa0c50bbdca2b354881b3dbf.webp";